<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center">
      <p>{{ $t('staffCollectedProduct.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteStaffCollectedProduct } from '@/api/goods/staffCollectedProductApi'
import { getShopId } from '@/api/shop/shopApi'
import { getUserInfo } from '@/api/user/indexApi'

export default {
  name: 'DeleteStaffCollectedProduct',
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        cpId: '',
        shopId: '',
        staffId: ''
      }
    }
  },
  methods: {
    async open(row) {
      this.dialogVisible = true
      this.deleteData.cpId = row.cpId
      this.deleteData.shopId = getShopId()
      try {
        const user = await getUserInfo()
        this.deleteData.staffId = user.userId || ''
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async confirmDelete() {
      try {
        await deleteStaffCollectedProduct(this.deleteData)
        this.$emit('refresh')
        this.$message.success(this.$t('common.submitSuccess'))
        this.closeDialog()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error)
      }
    }
  }
}
</script>

